export default "__VITE_ASSET__DgypOc2h__"